export default __webpack_public_path__ + "static/media/icon_acca.33a77cbb.svg";